module.exports = __webpack_public_path__ + "static/media/KarlMarkovics.512be89a.jpg";